module.exports = __webpack_public_path__ + "static/media/navigateIcon.f09d7fb8.svg";